import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/login/fulfilled', 'auth/fetchProfile/fulfilled'],
      },
    }),
  devTools: import.meta.env.MODE !== 'production',
})

// Infer types from the store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
